import * as React from 'react';
import { Link } from 'react-router-dom';
import validator from 'validator';
import { CONTACT_PATH_2, SourceSystem } from '@atlassian/cssxp-typescommon';
import { CommerceNote } from '@atlassian/cssxp-types-audit';
import { FormattedDate, ErrorRow, LoadingPlaceholderRows, LoadMoreRow, NoResultsRow } from '@css-xp/base';
import HistoricalNotesMessage from './historical-notes-message';

import './commerce-notes-list.scss';

export interface Props {
  notes: CommerceNote[];
  error: Error | null;
  isSearching: boolean;
  onLoadMoreClick: () => void;
  showLoadMore: boolean;
  totalHits: number;
  adaUrl: string;
  sourceSystem?: SourceSystem | null;
}

// Default Commerce Notes List for CommerceNoteSearch
// Please create a new list component if you need to make changes to data view
const CommerceNotesList = (props: Props) => {
  const { notes, isSearching, totalHits, onLoadMoreClick, showLoadMore, error, adaUrl, sourceSystem } = props;
  const colCount = 3;

  const buildAuthorDisplay = (author?: string) => {
    if (!author) {
      return;
    }

    if (validator.isEmail(author)) {
      return <Link to={`${CONTACT_PATH_2}/${encodeURIComponent(author)}`}>{author}</Link>;
    } else {
      return author;
    }
  };

  const hasNoResults = !isSearching && !error && notes.length === 0;

  return (
    <div>
      <h2>Audit trail</h2>
      <table id="audit-trail" data-testid="audit-trail" className="aui table-list table-search-results audit-table">
        <colgroup>
          <col className="col-30" />
          <col className="col-auto" />
          <col className="col-20" />
        </colgroup>
        {!hasNoResults && (
          <thead>
            <tr>
              <th>Date</th>
              <th>Update</th>
              <th>Made by</th>
            </tr>
          </thead>
        )}
        {notes.map((note) => {
          return (
            <tbody key={note.id}>
              <tr data-test-id="billing-note">
                <td>
                  <FormattedDate date={note.created} showTime={true} />
                </td>
                <td className="wrappable">{note.body}</td>
                <td>{buildAuthorDisplay(note.author)}</td>
              </tr>
            </tbody>
          );
        })}
        {isSearching && <LoadingPlaceholderRows colSpan={colCount} numberOfRows={3} />}
        {showLoadMore && (
          <LoadMoreRow colSpan={colCount} onLoadMoreClick={onLoadMoreClick} results={notes} totalHits={totalHits} />
        )}
        {error && <ErrorRow colSpan={colCount} error={error.message} />}
        {hasNoResults && <NoResultsRow colSpan={3} entitiesName="notes" />}
      </table>
      {/* Eventually should be equal to HAMS, needs to add source to other entities */}
      {sourceSystem !== SourceSystem.CCP && <HistoricalNotesMessage adaUrl={adaUrl} />}
    </div>
  );
};

export default CommerceNotesList;
